export const albumEngagementState = {
    defaultState: {albumEngagementChanges: {}},
    actions: {
        changeAlbumMediaEngagement: ({item, type, delta}, state) => {
            if (item.type === 'album' || !['likes', 'saves'].includes(type) || !delta) return state
            const albumIds = [...new Set([
                item.cityVisitId, item.islandVisitId, item.nationalParkVisitId,
                item.usStateVisitId, item.countryVisitId, item.continentVisitId,
            ].filter(Boolean))]
            const changes = {...state.albumEngagementChanges}
            albumIds.forEach(id => {
                changes[id] = {...changes[id], [type]: (changes[id]?.[type] || 0) + delta}
            })
            return {...state, albumEngagementChanges: changes}
        },
    },
}
